var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHtlPadelFilled = function SvgHtlPadelFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.635 13.957a.5.5 0 0 1-.408-.762l.87-1.406c.087-.148.171-.289.254-.423a5.2 5.2 0 0 0 .96-3.6c0-.062-.009-.123-.014-.186a.5.5 0 0 1 .005-.115c0-.03-.005-.061-.007-.092a3.79 3.79 0 0 1-.008-.248 5.45 5.45 0 0 1 .772-2.665 5.3 5.3 0 0 1 2.14-2.118 2.13 2.13 0 0 1 2.025-.1 2.125 2.125 0 0 1 .929 1.8c.005.081.008.164.008.248a5.45 5.45 0 0 1-.772 2.665 5.3 5.3 0 0 1-2.14 2.118 3.41 3.41 0 0 1-.35.151l-.072.037a5.376 5.376 0 0 0-2.355 2.2l-.395.638-.177.292a.493.493 0 0 1-.032.045l-.792 1.28a.5.5 0 0 1-.425.237l-.016.004ZM2.226 6.15a2 2 0 1 1 4 .003 2 2 0 0 1-4-.004v.001Z"
  })));
};
export default SvgHtlPadelFilled;